import React, { useState } from 'react';
import styled from 'styled-components';
import { CONTENT } from './content';
import { motion } from 'framer-motion';

const NavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background: #3D8DF5;
  border-bottom: 4px solid #000;
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const NavLinks = styled.div<{ $open: boolean }>`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    display: ${props => props.$open ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    background: #3D8DF5;
    border-bottom: 4px solid #000;
    padding: 20px;
    z-index: 1000;
  }
`;

const NavLink = styled(motion.a)`
  font-family: 'GROBOLD', sans-serif;
  color: #fff;
  text-decoration: none;
  font-size: 1.2rem;
  -webkit-text-stroke: 1px #000;
  cursor: pointer;
  
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: #F7E03C;
      transform: translateY(-2px);
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  font-family: 'GROBOLD', sans-serif;
  background: #F7E03C;
  border: 4px solid #000;
  padding: 10px;
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

export const RedesignNav: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <NavContainer>
      <NavLink href="/">
        <img src="/assets/img/logo.webp" alt="Zeus" style={{ height: 40 }} />
      </NavLink>
      <MobileMenuButton onClick={() => setOpen(!open)}>MENU</MobileMenuButton>
      <NavLinks $open={open}>
        <NavLink href="#home">HOME</NavLink>
        <NavLink href={CONTENT.menu.referral} target="_blank">REFERRAL</NavLink>
        <NavLink href="#tokenomics">TOKENOMICS</NavLink>
        <NavLink href="#roadmap">ROADMAP</NavLink>
        <NavLink href={CONTENT.menu.ens}>ENS</NavLink>
        <NavLink href={CONTENT.menu.governance}>GOVERNANCE</NavLink>
        <NavLink href={CONTENT.menu.earn} target="_blank">EARN</NavLink>
        <NavLink href={CONTENT.menu.bridge} target="_blank">BRIDGE</NavLink>
      </NavLinks>
    </NavContainer>
  );
};

const FooterContainer = styled.footer`
  padding: 40px;
  background: #000;
  color: #fff;
  text-align: center;
  font-family: 'GROBOLD', sans-serif;
`;

export const RedesignFooter: React.FC = () => {
  return (
    <FooterContainer>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
        {Object.entries(CONTENT.social).map(([k, link]) => (
          <a key={k} href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#F7E03C' }}>{k.toUpperCase()}</a>
        ))}
      </div>
      <div>
        <a href="/terms" style={{ color: '#fff', marginRight: 20 }}>Terms</a>
        <a href="/privacy" style={{ color: '#fff' }}>Privacy</a>
      </div>
      <p style={{ color: '#666', marginTop: 20 }}>© 2026 Zeus Pepe's Dog</p>
    </FooterContainer>
  );
};
